import React from 'react';
import ReservationBuilderConstants from './constants/ReservationBuilderConstants';

export default class ReservationBuilderNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }


  getInitState() {
    var state = {};
    state[ReservationBuilderConstants.ACCOMMODATIONS] = true;
    state[ReservationBuilderConstants.ADD_ONS] = false;
    state[ReservationBuilderConstants.REVIEW_SUMMARY] = false;
    state[ReservationBuilderConstants.CUSTOMER_INFORMATION] = false;
    state[ReservationBuilderConstants.ADDITIONAL_INFORMATION] = false;
    state[ReservationBuilderConstants.PAYMENT_INFORMATION] = false;
    state.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    return state;
  }

  render() {
    if (this.props.step !== ReservationBuilderConstants.SUCCESS) {
      return (
        <div>
          {this.renderExistingReservationMessage()}
          <div className="steps">
            <ul className="nav nav-wizard">
              {this.props.step !== ReservationBuilderConstants.ACCOMMODATIONS && this.state.isMobile ? null : <li className={this.props.step == ReservationBuilderConstants.ACCOMMODATIONS ? 'active accommodations-nav' : 'accommodations-nav'}><p data-step={ReservationBuilderConstants.ACCOMMODATIONS}>{I18n.t('accommodations')}</p></li>}        
              {this.props.step !== ReservationBuilderConstants.ADD_ONS && this.state.isMobile ? null : <li className={this.props.step == ReservationBuilderConstants.ADD_ONS ? 'active products-nav' : 'products-nav'}><p data-step={ReservationBuilderConstants.ADD_ONS}>{I18n.t('add_ons')}</p></li>}          
              {this.props.step !== ReservationBuilderConstants.REVIEW_SUMMARY && this.state.isMobile ? null : <li className={this.props.step == ReservationBuilderConstants.REVIEW_SUMMARY ? 'active confirm-nav' : 'confirm-nav'}><p data-step={ReservationBuilderConstants.REVIEW_SUMMARY}>{I18n.t('review')}</p></li>}
              {this.props.step !== ReservationBuilderConstants.CUSTOMER_INFORMATION && this.state.isMobile ? null : <li className={this.props.step == ReservationBuilderConstants.CUSTOMER_INFORMATION ? 'active customer-nav' : 'customer-nav'}><p data-step={ReservationBuilderConstants.CUSTOMER_INFORMATION}>{I18n.t('guest_details')}</p></li>}
              {this.props.forms.length > 0 ? this.props.step !== ReservationBuilderConstants.ADDITIONAL_INFORMATION && this.state.isMobile ? null : <li className={this.props.step == ReservationBuilderConstants.ADDITIONAL_INFORMATION ? 'active customer-nav' : 'customer-nav'}><p data-step={ReservationBuilderConstants.ADDITIONAL_INFORMATION}>{I18n.t('additional_information')}</p></li> : null}
              {this.props.step !== ReservationBuilderConstants.PAYMENT_INFORMATION && this.state.isMobile ? null : <li className={this.props.step == ReservationBuilderConstants.PAYMENT_INFORMATION ? 'active payment-nav' : 'payment-nav'}><p data-step={ReservationBuilderConstants.PAYMENT_INFORMATION}>{I18n.t('payment')}</p></li>}
            </ul>
          </div>
        </div>
      );
    }
    else {
      return(
        null
      );
    };
  };

  renderExistingReservationMessage() {
    if (this.props.existingReservation) {
      return (
        <div className="alert alert-warning">
          <h4 style={{ marginTop: 5, textAlign: 'center' }}><strong>{I18n.t('you_are_editing_an_exisiting_reservation')}</strong></h4>
          <hr />
          <p className="text-center">{I18n.t('editing_exisiting_reservation_text', { existing_reservation_confirmation_number: this.props.existingReservation.confirmation_number })}</p>
        </div>
      );
    }
  };


  jumpto = (e) => {
    e.preventDefault();
    // ReservationBuilderActions.jumptoStep(e.target.dataset.step);
  };

};
